import { FC } from "react";
import { RenderElementProps } from "slate-react";

import { EditorElementType } from "@smart/itops-serialisation-basic";

import { BlockQuote } from "./blockquote";
import { Link } from "./link";
import { BulletedList, ListItem, NumberedList } from "./list";
import { ElementRendererProps, Paragraph } from "./paragraph";
import { Placeholder } from "./placeholder";

const byElementType = {
  link: Link,
  "bulleted-list": BulletedList,
  "numbered-list": NumberedList,
  "list-item": ListItem,
  placeholder: Placeholder,
  paragraph: Paragraph,
  blockquote: BlockQuote,
};

export const Block = (
  props: RenderElementProps & {
    readOnly?: boolean;
    isLinkEnabled?: boolean;
    renderEditTo?: () => HTMLElement | null | undefined;
    showEditLink?: boolean;
  },
) => {
  const { element } = props;
  const Element = byElementType[element.type] as FC<
    ElementRendererProps<EditorElementType>
  >;
  return <Element {...props} />;
};
